import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AzoresBnB from "./App";
import Registry from "./Registry";

const path = window.location.pathname.replace(/\/+$/, "");
const Page = path === "/registry" ? Registry : AzoresBnB;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Page />
  </React.StrictMode>
);